const quoteSwiper = new Swiper("#quote-slider", {
    lazy: true,
    autoplay: {
        delay: document.querySelector('.quote-section').getAttribute('slide-speed'),
        disableOnInteraction: false
      },
    effect: "fade",
    fadeEffect: {
        crossFade: true
    }
});